import createReactComponent from '../createReactComponent';
export default createReactComponent('s-turn-down', 'IconSTurnDown', [
  ['path', { d: 'M7 5a2 2 0 1 1 -4 0a2 2 0 0 1 4 0z', key: 'svg-0' }],
  [
    'path',
    { d: 'M5 7v9.5a3.5 3.5 0 0 0 7 0v-9a3.5 3.5 0 0 1 7 0v13.5', key: 'svg-1' },
  ],
  ['path', { d: 'M16 18l3 3l3 -3', key: 'svg-2' }],
]);
